<template>
    <div class="container teachers-container">
        <h1>{{heading}}</h1>
        <teachers :teachers="teacherList"></teachers>
    </div>
</template>

<script>
import Teachers from "@/components/teachers/Teachers.vue";

export default {
  name: `MyTeachersPage`,

  components: {
    Teachers
  },
  computed: {
    heading() {
      if (this.$route.name === `teachers`) {
        return `המורים שלנו`;
      }
      return `המורים שלי`;
    },

    teacherList() {
      if (this.$route.name === `teachers`) {
        return this.$store.getters.teachers;
      }
      return this.$store.state.user.myTeachers;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  }

  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.teachers-container {
  h1 {
    margin: 20px auto;
    padding: 0 15px;
  }
  .teachers {
    text-align: right;
    max-width: 100%;
  }
}

@media screen and (min-width: 1025px) {
  .teachers-container {
    h1 {
      padding: 0;
    }
  }
}
</style>
